import { getMicroserviceBaseContext } from '../../constants/api-routing';

const avatarContext = getMicroserviceBaseContext('avatar');

export const AVATAR_SERVICE = {
    update_avtar_enabled: `${avatarContext}update_avtar_enabled`,
    avatar_time_allocation_by_user_id: `${avatarContext}avatar_time_allocation_by_user_id`,
    update_avatar_time_allocation: `${avatarContext}update_avatar_time_allocation`,
    create_avatar_time_allocation: `${avatarContext}create_avatar_time_allocation`,
    stopAvatarConversation: `${avatarContext}stop_avatar_conversation`,
}
